import axios from 'axios';
import qs from 'qs';
import aes from '@/utils/aes.js'
console.log(process.env.NODE_ENV)

const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    baseURL: process.env.NODE_ENV === 'development'?'https://xpjckj.cn/yunxp/request_user_v1.php':'https://xpjckj.cn/yunxp/request_user_v1_pub.php',
    timeout: 5000
});

service.defaults.headers.post['Content-Type']='application/x-www-form-urlencoded;charset=UTF-8'

service.interceptors.request.use(
    config => {
        config.data.timestamp=Date.now()
        let ordered={}
        Object.keys(config.data).sort().forEach(key=>{
            ordered[key]=config.data[key]
        })
        config.data=qs.stringify(ordered);
        let aesdata=config.data.slice(0,100)+config.data.slice(-100);
        console.log('interceptors.request',aesdata)
        let key='yxpAuthorizati'
        let text=aesdata//Date.now()+'_fazkio89dsa31_'+Date.now()
        let auth=aes.aesEncrypt(text,key)
        config.headers.Authorization ='Bearer '+auth
        console.log('auth',auth)
        return config;
        // let key='yxpAuthorizati'
        // let text=Date.now()+'_fazkio89dsa31_'+Date.now()
        // let auth=aes.aesEncrypt(text,key)
        // config.data.env='d'
        // if (process.env.NODE_ENV != 'development'){
        //     //config.headers.Authorization = auth
        //     config.data.env='p'
        // }
        // console.log('auth',auth)
        // config.data.sign=auth
        // config.data=qs.stringify(config.data);
        // return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

export default service;